import styled from "styled-components";
import { Input, Select as SelectAntd } from "antd";
import DataTable from "react-data-table-component";

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #fff;
`;

export const SearchEventContainer = styled.div`
  width: 529px;
  flex-direction: column;
  display: flex;
  gap: 9.37px;
`;

export const Span = styled.span`
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 18.86px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #000000d9;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #0000001f;
  margin: 24px 0;
`;

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  & > div {
    display: flex;
    gap: 16px;
    align-items: center;
  }

  & > div:last-child {
    flex: 1;
    justify-content: flex-end;
  }
`;

export const HeaderTitle = styled.h1`
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #002244;
  margin-bottom: 0;
`;

export const Search = styled(Input)`
  max-width: 473px;
  border-radius: 5px;
  padding: 8px 16.8px;

  & > span {
    margin-left: 2.5px;
    margin-right: 10.25px;
  }

  &.ant-input-affix-wrapper:focus,
  &.ant-input-affix-wrapper-focused {
    border-color: #002244;
    box-shadow: 0 0 0 2px rgba(0, 34, 68, 0.2) !important;
  }

  &:hover {
    border-color: #002244 !important;
  }
`;

export const Select = styled(SelectAntd)`
  & > div {
    border-radius: 5px !important;
    height: 40px !important;

    & > span {
      display: flex;
      align-items: center;
    }
  }
  svg {
    transition: all 0.2s ease-in-out;
    fill: #444444;
  }

  &.ant-select-open svg {
    transform: rotate(180deg);
  }
`;

export const EmptyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #002244;
  gap: 4px;
  margin: 90px 0px;
`;

export const HighlightText = styled.p`
  margin-bottom: 0px;
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
`;

export const Text = styled.p`
  margin-bottom: 0px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
`;

export const customStyles = {
  headRow: {
    style: {
      backgroundColor: "#f6f6f6",
    },
  },
  headCells: {
    style: {
      color: "#533d59",
      fontSize: "14px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      textAlign: "left",
    },
  },
  rows: {
    style: {
      color: "#002244",
      fontSize: "14px",
      fontWeight: "600",
      backgroundColor: "#fff",
      "&:hover": {
        backgroundColor: "rgba(17, 167, 217, 0.05) !important",
      },
    },
  },
};

export const TableContainer = styled.div`
  .rdt_Table {
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #e2e8f0 !important;
  }

  .rdt_Pagination {
    border-top: 0px;
  }
`;

export const StatusBadge = styled.div`
  width: 120px;
  height: 24px;
  background: ${({ status }) => (status === "created" ? "#33D27E" : "#3D3D3D")};
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 20px;
`;
